import './global.js';
import chainedSelectorsWrap from "./includes/techCalc";
import wrapJewelryTab from "./includes/silverGoldCalc";
import { v$ } from './includes/helpers';
import { closePopup, openPopup } from './includes/popupForm';
import moment from "moment";

let parent = document.querySelector('#appliances');
chainedSelectorsWrap(parent);
let parentGold = document.querySelector('#gold');
wrapJewelryTab({product: 'gold_one_day', parent:parentGold});
let parentSilver = document.querySelector('#silver');
wrapJewelryTab({product: 'silver_one_day', parent:parentSilver});

const openPromoCodePopup = () => {
  const promoCodeLink = v$('.promo-code-text'),
    promoPopUp = v$('#promo')[0],
    promoPopUpClose =v$('#promo .popup-close')[0],
    promoCodeWrap = v$('.promo-code-wrap');

  if (promoCodeWrap) {
    promoCodeLink.forEach( (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        openPopup(promoPopUp);
      })
    })

    promoPopUpClose.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup(promoPopUp);
    })
  }
}
openPromoCodePopup();


// tech-tabs switch
{
  const tabButtons = document.querySelectorAll('.tech-eval-tabs__item')
  const calcTabView = document.querySelector('.apliances-view-wrapper#appliances-calc')
  const sellTabView = document.querySelector('.apliances-view-wrapper#appliances-sell')
  const sellTimer = document.querySelector('#appliances-sell-timer')
  const actionLink = document.querySelector('a.action-link')

  tabButtons.forEach(item => {
    item.addEventListener('click', tabClickHandler)
  })

  actionLink.addEventListener('click', () => {
    linkTimerStop()
  })

  function tabClickHandler(evt) {
    tabButtons.forEach(item => {
      item.classList.remove('tab-active')
      if (item.contains(evt.target)) {
        item.classList.add('tab-active')
        calcTabView.classList.remove('view-active')
        sellTabView.classList.remove('view-active')
        if (item.dataset.tab === 'calc') {
          calcTabView.classList.add('view-active')
          linkTimerStop()
        }
        if (item.dataset.tab === 'sell') {
          sellTabView.classList.add('view-active')
          linkTimerStart(sellTimer.dataset.timer)
        }
      }
    })
  }

  var timerInterval;

  function linkTimerStart(secondsCountInit) {
    sellTimer.textContent = `${secondsCountInit} сек`;

    let timestamp = new Date()
    let duration = moment.duration({'seconds': secondsCountInit});
    let step = 1

    timerInterval = setInterval(function() {
      timestamp = new Date(timestamp.getTime() - step * 1000);
      duration = moment.duration(duration.asSeconds() - step, 'seconds');
      sellTimer.textContent = `${duration.asSeconds()} сек`;
      if (duration.asSeconds() < 1) {
        clearInterval(timerInterval)
        actionLink.click()
      }
    },1000);
  }

  function linkTimerStop() {
    clearInterval(timerInterval)
  }

  const mainTabs = document.querySelectorAll('.tabs_inner-label')
  mainTabs.forEach(item => {
    item.addEventListener('click', () => {
      if (item.getAttribute('for') !== 'tab3') {
        document.querySelector('.tech-eval-tabs__item[data-tab="calc"]').click()
      }
    })
  })
}
// END tech-tabs switch
